/**
 * Helper function to get a cookie.
 *
 * Works in both React Server Components and client-side components.
 */
export async function getServerOrClientCookies(key: string) {
  if (typeof window === "undefined") {
    const { cookies } = await import("next/headers")
    const data = await cookies()
    return data.get(key)?.value
  } else {
    const { default: Cookies } = await import("js-cookie")
    return Cookies.get(key)
  }
}
